<div class="dropdown" dropdown>
  <button class="btn dropdown-toggle" [ngClass]="getClass()" dropdownToggle type="button" aria-controls="dropdown-menu" role="button">
    <span>{{resolveName(selectedItem)}}</span>
    <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
  </button>
  <ul class="dropdown-menu w-100" *dropdownMenu id="dropdown-menu" role="menu" aria-labelledby="button-animated">
    <li *ngFor="let item of items" role="menuitem" class="dropdown-item cursor-pointer text-truncate" (click)="onItemClick(item)" data-testid="dropdown-item">
      {{resolveName(item)}}
    </li>
  </ul>
</div>
